import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class BlockPushOffres {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.push-offres__swiper', {
      modules: [Pagination],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 20,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 3,
          spaceBetween: 24
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 24
        }
      }
    });
  }



}
export const blockPushOffres = new BlockPushOffres();
